"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeybindResponseT = exports.KeybindResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const keybind_js_1 = require("../../solarxr-protocol/rpc/keybind.js");
class KeybindResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsKeybindResponse(bb, obj) {
        return (obj || new KeybindResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsKeybindResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new KeybindResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    keybind(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new keybind_js_1.Keybind()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    keybindLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    defaultKeybinds(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new keybind_js_1.Keybind()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    defaultKeybindsLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startKeybindResponse(builder) {
        builder.startObject(2);
    }
    static addKeybind(builder, keybindOffset) {
        builder.addFieldOffset(0, keybindOffset, 0);
    }
    static createKeybindVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startKeybindVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addDefaultKeybinds(builder, defaultKeybindsOffset) {
        builder.addFieldOffset(1, defaultKeybindsOffset, 0);
    }
    static createDefaultKeybindsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startDefaultKeybindsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endKeybindResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createKeybindResponse(builder, keybindOffset, defaultKeybindsOffset) {
        KeybindResponse.startKeybindResponse(builder);
        KeybindResponse.addKeybind(builder, keybindOffset);
        KeybindResponse.addDefaultKeybinds(builder, defaultKeybindsOffset);
        return KeybindResponse.endKeybindResponse(builder);
    }
    unpack() {
        return new KeybindResponseT(this.bb.createObjList(this.keybind.bind(this), this.keybindLength()), this.bb.createObjList(this.defaultKeybinds.bind(this), this.defaultKeybindsLength()));
    }
    unpackTo(_o) {
        _o.keybind = this.bb.createObjList(this.keybind.bind(this), this.keybindLength());
        _o.defaultKeybinds = this.bb.createObjList(this.defaultKeybinds.bind(this), this.defaultKeybindsLength());
    }
}
exports.KeybindResponse = KeybindResponse;
class KeybindResponseT {
    constructor(keybind = [], defaultKeybinds = []) {
        this.keybind = keybind;
        this.defaultKeybinds = defaultKeybinds;
    }
    pack(builder) {
        const keybind = KeybindResponse.createKeybindVector(builder, builder.createObjectOffsetList(this.keybind));
        const defaultKeybinds = KeybindResponse.createDefaultKeybindsVector(builder, builder.createObjectOffsetList(this.defaultKeybinds));
        return KeybindResponse.createKeybindResponse(builder, keybind, defaultKeybinds);
    }
}
exports.KeybindResponseT = KeybindResponseT;
